import classNames from "classnames";
import React, { useRef } from "react";
import { FaCaretDown } from "react-icons/fa";
import ClipLoader from "react-spinners/ClipLoader";
import "./style.scss";

interface Props {
  values?: {
    title: string;
    mobileTitle: string;
    id: any;
    enabled: boolean;
  }[];
  label?: string;
  className?: string;
  placeholder?: string;
  isLoading?: boolean;
  disabled?: boolean;
  value?: string;
  onChange?(param: string): void;
  width?: number;
  desktopWidth?: number;
  mobileWidth?: number;
  isMobile?: boolean;
}

export const TopSelect: React.FC<Props> = ({
  className,
  values = [],
  placeholder,
  isLoading = false,
  disabled = false,
  value = "",
  onChange = () => {},
  width,
  isMobile = false,
}) => {
  const actionRef = useRef<HTMLDivElement>(null);

  const handleChange = (param: any) => {
    actionRef.current && actionRef.current.blur();
    onChange(param);
  };

  return (
    <div
      className={classNames("top-select", className)}
      style={{ width: width || "auto" }}
    >
      <div
        className="top-select__container"
        ref={actionRef}
        tabIndex={disabled ? undefined : 0}
      >
        <div
          className={classNames("top-select__main", {
            active: value,
          })}
        >
          {value
            ? isMobile
              ? values.find((item) =>
                  +item.id ? +item.id === +value : item.id === value,
                )?.mobileTitle
              : values.find((item) =>
                  +item.id ? +item.id === +value : item.id === value,
                )?.title
            : placeholder}
          <FaCaretDown className="top-select__arrow" />
        </div>
        <div className={classNames("top-select__menu")}>
          {isLoading ? (
            <ClipLoader
              size={40}
              color="#297D4A"
              cssOverride={{
                display: "block",
                margin: "20px auto",
              }}
            />
          ) : values.length > 0 ? (
            values.map(({ title, mobileTitle, id: itemVal, enabled }) => {
              return (
                <div
                  className={classNames("top-select__menu-item", {
                    active: value === itemVal,
                    disabled: !enabled,
                  })}
                  key={itemVal}
                  onClick={() => enabled && handleChange(itemVal)}
                >
                  <span>{isMobile ? mobileTitle : title}</span>
                </div>
              );
            })
          ) : (
            <div className="my-3 text-gray text-center">Empty</div>
          )}
        </div>
      </div>
    </div>
  );
};
